/**
 * Resuelve destino de navegación desde payload FCM (deep link opcional).
 * Contrato: data.routeName | route_name | screen, o data.path | routePath | route_path
 */
export const resolvePushNavigationTarget = (data) => {
    if (!data)
        return null;
    const pick = (...keys) => {
        for (const key of keys) {
            const value = data[key];
            if (typeof value === "string" && value.trim().length > 0) {
                return value.trim();
            }
        }
        return undefined;
    };
    const navigationType = pick("navigationType", "navigation_type");
    const conversationId = pick("conversationId", "conversation_id");
    if (navigationType === "CHAT_CONVERSATION" || conversationId) {
        return conversationId
            ? { name: "messaging-conversation" }
            : null;
    }
    if (navigationType === "TRANSPORT_TRIP") {
        const tripId = pick("tripId", "trip_id");
        if (tripId) {
            return {
                path: `/user/transporte/mapa?trip_id=${encodeURIComponent(tripId)}`,
            };
        }
        return { name: "transporte-mis" };
    }
    const routeName = pick("routeName", "route_name", "screen", "screenName");
    if (routeName) {
        return { name: routeName };
    }
    const path = pick("path", "routePath", "route_path", "url");
    if (path) {
        if (path.startsWith("http://") || path.startsWith("https://")) {
            try {
                const url = new URL(path);
                return { path: `${url.pathname}${url.search}` };
            }
            catch {
                return null;
            }
        }
        return { path: path.startsWith("/") ? path : `/${path}` };
    }
    return null;
};
